"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = smallText;
function smallText() {
  return "\n    font-size: 14px;\n    line-height: 18px;\n  ";
}